<template>
    <div class="w-14 h-14 rounded-lg border-gray-400 border relative" :style="backgroundGradient">
    </div>
</template>

<script>
export default {
    props: ['color1', 'color2'],
    computed: {
        backgroundGradient() {
            return 'background-image: linear-gradient(to top right, '+this.color1+' 50%, '+this.color2+' 50%);'
        }
    }
}
</script>

